export const oimTableConfig = {
    component: 'il_ocean_import',
    formState: [
        'oimMainUpdateForm',
        'oimHblUpdateForm',
        'oimContainerUpdateForm',
        'oimContainerAliasUpdateForm',
        'oimStatusUpdateForm',
        'oimCommentUpdateForm',
        'oimPresetUpdateForm',
    ],
    keyName: ['il_ocean_import_id', 'il_ocean_import_hbl_id'],
    hblOutputKeys: ['hbl', 'il_trade_partner_id_shipper', 'il_trade_partner_id_consignee', 'reference'],
    outputKeys: ['hbl', 'cntr_number', 'volume', 'il_location_id_deliver_to', 'il_trade_partner_id'],
    stringColumns: [
        'il_trade_partner_id_consignee',
        'il_trade_partner_id_shipper',
        'cntr_number',
        'hbl',
        'volume',
        'il_location_id_deliver_to',
        'il_trade_partner_id',
        'status',
        'il_opus_reference_preset',
        'reference',
    ],
    tableName: [
        'il_ocean_import',
        'il_ocean_import_hbl',
        'il_ocean_import_cntr',
        'il_ocean_import_cntr_alias',
        'il_status',
        'il_rate',
        'il_filter',
        'il_comment',
        'il_dispute',
        'il_preset',
    ],
    reducerMap: {
        il_ocean_import: 'setOimMainFormData',
        il_ocean_import_hbl: 'setOimHblFormData',
        il_ocean_import_cntr: 'setOimContainerFormData',
        il_ocean_import_cntr_alias: 'setContainerAliasFormData',
        il_status: 'setOimStatusFormData',
        il_rate: 'setOimRateFormData',
        il_filter: 'setFilterViewFormData',
        il_comment: 'setOimCommentFormData',
        il_dispute: 'setOimDisputeFormData',
        il_preset: 'setOimPresetFormData',
    },
    reducerCompleteMap: {
        il_ocean_import: 'addOimMainForm',
        il_ocean_import_hbl: 'addOimHBL',
        il_ocean_import_cntr: 'addOimContainer',
        il_ocean_import_cntr_alias: 'addOimAlias',
        il_status: 'addOimStatus',
        il_rate: 'addOimRate',
        il_comment: 'addOimComment',
        il_dispute: 'addOimDispute',
    },
    reducerActions: ['setOimMainUpdateData'],
    dateFormat: ['etd', 'eta', 'feta', 'deta'],
    locationField: ['il_location_id_pol', 'il_location_id_pod', 'il_location_id_fpod'],
    pinnedColumns: {
        left: ['__detail_panel_toggle__', 'selection', 'il_team_id', 'il_opus_reference_id', 'il_trade_partner_id_client', 'actions'],
        right: ['etd', 'eta', 'feta', 'progress', 'status'],
    },
};

export const oexTableConfig = {
    component: 'il_ocean_export',
    formState: [
        'oexMainUpdateForm',
        'oexHblUpdateForm',
        'oexContainerUpdateForm',
        null,
        'oexStatusUpdateForm',
        'oexCommentUpdateForm',
        'oexPresetUpdateForm',
    ],
    keyName: ['il_ocean_export_id', 'il_ocean_export_hbl_id'],
    hblOutputKeys: ['hbl', 'il_trade_partner_id_shipper', 'il_trade_partner_id_consignee', 'reference'],
    outputKeys: ['hbl', 'cntr_number', 'volume', 'il_location_id_pick_up', 'il_trade_partner_id'],
    stringColumns: [
        'il_trade_partner_id_consignee',
        'il_trade_partner_id_shipper',
        'hbl',
        'cntr_number',
        'volume',
        'il_location_id_pick_up',
        'il_trade_partner_id',
        'status',
        'il_opus_reference_preset',
        'reference',
    ],
    tableName: [
        'il_ocean_export',
        'il_ocean_export_hbl',
        'il_ocean_export_cntr',
        'il_status',
        'il_rate',
        'il_comment',
        'il_dispute',
        'il_preset',
    ],
    reducerMap: {
        il_ocean_export: 'setOexMainFormData',
        il_ocean_export_hbl: 'setOexHblFormData',
        il_ocean_export_cntr: 'setOexContainerFormData',
        il_preset: 'setOexPresetFormData',
        il_status: 'setOexStatusFormData',
        il_rate: 'setOexRateFormData',
        il_comment: 'setOexCommentFormData',
        il_dispute: 'setOexDisputeFormData',
    },
    reducerCompleteMap: {
        il_ocean_export: 'addOexMainForm',
        il_ocean_export_hbl: 'addOexHBL',
        il_ocean_export_cntr: 'addOexContainer',
        il_status: 'addOexStatus',
        il_rate: 'addOexRate',
        il_comment: 'addOexComment',
        il_dispute: 'addOexDispute',
    },
    reducerActions: ['setOexMainUpdateData'],
    dateFormat: ['doc_cut', 'port_cut', 'etd', 'eta', 'feta'],
    locationField: ['il_location_id_pol', 'il_location_id_pod', 'il_location_id_fpod'],
    pinnedColumns: {
        left: ['__detail_panel_toggle__', 'selection', 'il_team_id', 'il_opus_reference_id', 'il_trade_partner_id_client', 'actions'],
        right: ['doc_cut', 'port_cut', 'etd', 'eta', 'feta', 'progress', 'status'],
    },
};

export const aimTableConfig = {
    component: 'il_air_import',
    formState: [
        'aimMainUpdateForm',
        'aimHblUpdateForm',
        'aimContainerUpdateForm',
        null,
        'aimStatusUpdateForm',
        'aimCommentUpdateForm',
        'aimPresetUpdateForm',
    ],
    keyName: ['il_air_import_id', 'il_air_import_hbl_id'],
    hblOutputKeys: ['hawb', 'il_trade_partner_id_shipper', 'il_trade_partner_id_consignee', 'reference'],
    outputKeys: [
        'hawb',
        'alias',
        'il_opus_vessel_id',
        'quantity',
        'il_opus_volume_unit_id',
        'weight',
        'il_location_id_deliver_to',
        'il_trade_partner_id',
    ],
    stringColumns: [
        'il_trade_partner_id_consignee',
        'il_trade_partner_id_shipper',
        'hawb',
        'alias',
        'il_opus_vessel_id',
        'quantity',
        'il_opus_volume_unit_id',
        'weight',
        'il_location_id_deliver_to',
        'il_trade_partner_id',
        'status',
        'il_opus_reference_preset',
        'reference',
    ],
    tableName: [
        'il_air_import',
        'il_air_import_hbl',
        'il_air_import_hbl_alias',
        'il_status',
        'il_rate',
        'il_comment',
        'il_dispute',
        'il_preset',
    ],
    reducerMap: {
        il_air_import: 'setAimMainFormData',
        il_air_import_hbl: 'setAimHblFormData',
        il_air_import_hbl_alias: 'setAimContainerFormData',
        il_preset: 'setAimPresetFormData',
        il_status: 'setAimStatusFormData',
        il_rate: 'setAimRateFormData',
        il_comment: 'setAimCommentFormData',
        il_dispute: 'setAimDisputeFormData',
    },
    reducerCompleteMap: {
        il_air_import: 'addAimMainForm',
        il_air_import_hbl: 'addAimHBL',
        il_air_import_hbl_alias: 'addAimContainer',
        il_status: 'addAimStatus',
        il_rate: 'addAimRate',
        il_comment: 'addAimComment',
        il_dispute: 'addAimDispute',
    },
    reducerActions: ['setAimMainUpdateData'],
    dateFormat: ['etd', 'eta', 'feta'],
    locationField: ['il_location_id_aol', 'il_location_id_aod', 'il_location_id_faod'],
    pinnedColumns: {
        left: ['__detail_panel_toggle__', 'selection', 'il_team_id', 'il_opus_reference_id', 'il_trade_partner_id_client', 'actions'],
        right: ['etd', 'eta', 'feta', 'progress', 'status'],
    },
};

export const aexTableConfig = {
    component: 'il_air_export',
    formState: [
        'aexMainUpdateForm',
        'aexHblUpdateForm',
        'aexContainerUpdateForm',
        null,
        'aexStatusUpdateForm',
        'aexCommentUpdateForm',
        'aexPresetUpdateForm',
    ],
    keyName: ['il_air_export_id', 'il_air_export_hbl_id'],
    hblOutputKeys: ['hawb', 'il_trade_partner_id_shipper', 'il_trade_partner_id_consignee', 'reference'],
    outputKeys: [
        'hawb',
        'alias',
        'il_opus_vessel_id',
        'quantity',
        'il_opus_volume_unit_id',
        'weight',
        'il_location_id_pick_up',
        'il_trade_partner_id',
    ],
    stringColumns: [
        'il_trade_partner_id_consignee',
        'il_trade_partner_id_shipper',
        'hawb',
        'alias',
        'il_opus_vessel_id',
        'quantity',
        'il_opus_volume_unit_id',
        'weight',
        'il_location_id_pick_up',
        'il_trade_partner_id',
        'status',
        'il_opus_reference_preset',
        'reference',
    ],
    tableName: [
        'il_air_export',
        'il_air_export_hbl',
        'il_air_export_hbl_alias',
        'il_status',
        'il_rate',
        'il_comment',
        'il_dispute',
        'il_preset',
    ],
    reducerMap: {
        il_air_export: 'setAexMainFormData',
        il_air_export_hbl: 'setAexHblFormData',
        il_air_export_hbl_alias: 'setAexContainerFormData',
        il_preset: 'setAexPresetFormData',
        il_status: 'setAexStatusFormData',
        il_rate: 'setAexRateFormData',
        il_comment: 'setAexCommentFormData',
        il_dispute: 'setAexDisputeFormData',
    },
    reducerCompleteMap: {
        il_air_export: 'addAexMainForm',
        il_air_export_hbl: 'addAexHBL',
        il_air_export_hbl_alias: 'addAexContainer',
        il_status: 'addAexStatus',
        il_rate: 'addAexRate',
        il_comment: 'addAexComment',
        il_dispute: 'addAexDispute',
    },
    reducerActions: ['setAexMainUpdateData'],
    dateFormat: ['doc_cut', 'port_cut', 'etd', 'eta', 'feta'],
    locationField: ['il_location_id_aol', 'il_location_id_aod', 'il_location_id_faod'],
    pinnedColumns: {
        left: ['__detail_panel_toggle__', 'selection', 'il_team_id', 'il_opus_reference_id', 'il_trade_partner_id_client', 'actions'],
        right: ['doc_cut', 'port_cut', 'etd', 'eta', 'feta', 'progress', 'status'],
    },
};

export const truckingTableConfig = {
    component: 'il_ftl_ltl',
    formState: [
        'truckingMainUpdateForm',
        'truckingBolUpdateForm',
        '', // N/A
        null,
        'truckingStatusUpdateForm',
        'truckingCommentUpdateForm',
        'truckingPresetUpdateForm',
    ],
    keyName: ['il_ftl_ltl_id'],
    hblOutputKeys: ['alias', 'reference'],
    outputKeys: [
        'alias',
        'quantity',
        'il_opus_volume_unit_id',
        'il_location_id_pick_up',
        'il_location_id_deliver_to',
        'il_trade_partner_id',
    ],
    stringColumns: [
        'alias',
        'quantity',
        'il_opus_volume_unit_id',
        'il_location_id_pick_up',
        'il_location_id_deliver_to',
        'il_trade_partner_id',
        'status',
        'il_opus_reference_preset',
        'reference',
    ],
    tableName: [
        'il_ftl_ltl',
        'il_ftl_ltl_alias',
        'il_preset_ftl_ltl',
        'il_status',
        'il_rate',
        'il_comment',
        'il_dispute',
        'il_preset',
    ],
    reducerMap: {
        il_ftl_ltl: 'setTruckingMainFormData',
        il_ftl_ltl_alias: 'setTruckingHblFormData',
        il_preset: 'setTruckingPresetFormData',
        il_status: 'setTruckingStatusFormData',
        il_rate: 'setTruckingRateFormData',
        il_comment: 'setTruckingCommentFormData',
        il_dispute: 'setTruckingDisputeFormData',
    },
    reducerCompleteMap: {
        il_ftl_ltl: 'addTruckingMainForm',
        il_ftl_ltl_alias: 'addBOL',
        il_status: 'addTruckingStatus',
        il_rate: 'addTruckingRate',
        il_comment: 'addTruckingComment',
        il_dispute: 'addTruckingDispute',
    },
    reducerActions: ['setTruckingMainUpdateData'],
    dateFormat: ['etd', 'eta', 'feta'],
    locationField: [],
    pinnedColumns: {
        left: ['__detail_panel_toggle__', 'selection', 'il_team_id', 'il_opus_reference_id', 'il_trade_partner_id_client', 'actions'],
        right: ['etd', 'eta', 'feta', 'progress', 'status'],
    },
};
